function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.1337,
  cy: 28.1337,
  r: 28.1337,
  fill: "#27AE60"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.431 17.8525L38.6825 14.8884C38.5665 14.7926 38.4231 14.7242 38.2592 14.7242C38.0954 14.7242 37.9451 14.7926 37.8291 14.8953L24.1941 32.4606C24.1941 32.4606 18.8343 27.2923 18.6841 27.1417C18.5339 26.9911 18.3359 26.7378 18.0354 26.7378C17.735 26.7378 17.5985 26.95 17.4414 27.1075C17.3254 27.2307 15.4136 29.2432 14.4714 30.2427C14.4167 30.3043 14.3826 30.3385 14.3348 30.3864C14.2529 30.5028 14.1982 30.6328 14.1982 30.7766C14.1982 30.9272 14.2529 31.0504 14.3348 31.1668L14.526 31.3448C14.526 31.3448 24.037 40.5039 24.1941 40.6613C24.3511 40.8188 24.5423 41.0173 24.8222 41.0173C25.0953 41.0173 25.3206 40.7229 25.4504 40.5929L42.4583 18.6876C42.5402 18.5713 42.5948 18.4412 42.5948 18.2906C42.5948 18.1195 42.5266 17.9757 42.431 17.8525Z",
  fill: "#F2F2F2"
});

var SvgComplete = function SvgComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complete.2adb69d2.svg";
export { ForwardRef as ReactComponent };